import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import DashboardLayout from '../../components/sidebar';
import {
  ProtectedRoute,
  DashboardRoute,
  MyWorkspaceRoute,
  NotificationRoute,
  MenuRoute,
  ScheduleRoute,
  TodoRoute,
  EmployeeServiceRoute,
  HodRoute,
  RefferelRoute,
  AnalyticsRoute,
  MasterRoute,
  SpeakProRoute,
  AssetMangementRoute,
  CareerRoute,
} from '../route/index';
import DashboardRouter from './DashboardRouter';
import NotificationRouter from './NotificationRouter';
import MyWorkspaceRouter from './MyWorkspaceRouter';
import MenuRouter from './MenuRouter';
import ScheduleRouter from './ScheduleRouter';
import TodoRouter from './TodoRouter';
import EmployeeServiceRouter from './EmployeeServiceRouter';
import PrivilegesRouter from './PrivilegesRouter';
import RefferelRouter from './RefferelRouter';
import AttendanceCheck from '../route/AttendanceCheck';
import AnalyticsRouter from './AnalyticsRouter';
import Page404 from '../../views/user/Auth/Page404';
import MasterRouter from './MasterRouter';
import SpeakProRouter from './SpeakProRouter';
import HelpAndSupportRouter from './HelpAndSupportRouter';
import HelpAndSupportRoute from '../route/HelpAndSupportRoute';
import CheckComponensatoryLeave from '../route/CheckComponensatoryLeave'; //CONDITION WRAPPER  OLD
import CabinBookigRoute from '../route/CabinBookingRoute';
import CabinBookingRouter from './CabinBookingRouter';
import StudentPortalRoute from '../route/StudentPortalRoute';
import StudentPortalRouter from './StudentPortalRouter';
import PermissionRoute from '../route/PermissionRoute';
import PermissionRouter from './PermissionRouter';
import AssetmanagementRouter from './AssetmanagementRouter';
import AppraisalManagementRoute from '../route/AppraisalManagementRoute';
import AppraisalManagementRouter from './AppraisalManagementRouter';
import PointTrackerRoute from '../route/PointTrackerRoute';
import PointTrackerRouter from './PointTrackerRouter';
import TopManagementRoute from '../route/TopManagementRoute';
import TopManagementRouter from './TopManagementRouter';
import RestrictionWrapper from './RestrictionWrapper';
import TaskManagementRoute from '../route/TaskManagementRoute';
import TaskManagementRouter from './TaskManagementRouter';
import GrievanceRoute from '../route/myworkspace/GrievanceRoute';
import GrievanceRouter from './Grievance';
import CimsRoute from '../route/CimsRoute';
import CimsRouter from './CimsRouter';
import MagicLampRouter from './MagicLampRouter';
import CareerRouter from './CareerRouter';
import RetentionRouter from '../../views/retention/RetentionRouter';

const MainRouter = () => {
  return (
    <Routes>
      <Route
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route element={<AttendanceCheck />}>
          {/* <Route element={<RestrictionWrapper />}> */}
          <Route index path="/" element={<Navigate to="/dashboard" />} />

          <Route
            path="/dashboard/*"
            element={
              <DashboardRoute>
                <DashboardRouter />
              </DashboardRoute>
            }
          />
          {/* <Route path="/feedback" element={<Feedback />} /> */}
          {/* <Route path="/mystudents" element={<MyStudents />} /> */}

          <Route
            path="my-workspace/*"
            element={
              <MyWorkspaceRoute>
                <MyWorkspaceRouter />
              </MyWorkspaceRoute>
            }
          />
          {/* Retention workspace — per-student journey, inside the portal layout (RETENTION_WORKFLOW.md §2.2). */}
          <Route path="student-journey/*" element={<RetentionRouter />} />
          <Route
            path="cabin-booking/*"
            element={
              <CabinBookigRoute>
                <CabinBookingRouter />
              </CabinBookigRoute>
            }
          />
          <Route
            path="assessment-tool/*"
            element={
              <SpeakProRoute>
                <SpeakProRouter />
              </SpeakProRoute>
            }
          />

          <Route
            path="masters/*"
            element={
              <MasterRoute>
                <MasterRouter />
              </MasterRoute>
            }
          />

          <Route
            path="analytics/*"
            element={
              <AnalyticsRoute>
                <AnalyticsRouter />
              </AnalyticsRoute>
            }
          />

          {/* Magic Lamp — Lucky Spin. No extra guard: the portal's
              ProtectedRoute above already requires a signed-in employee. */}
          <Route path="magic-lamp/*" element={<MagicLampRouter />} />

          <Route
            path="/notifications/*"
            element={
              <NotificationRoute>
                <NotificationRouter />
              </NotificationRoute>
            }
          />

          <Route
            path="/menu/*"
            element={
              <MenuRoute>
                <MenuRouter />
              </MenuRoute>
            }
          />

          <Route
            path="/schedules/*"
            element={
              <ScheduleRoute>
                <ScheduleRouter />
              </ScheduleRoute>
            }
          />
          <Route
            path="todo/*"
            element={
              <TodoRoute>
                <TodoRouter />
              </TodoRoute>
            }
          />

          <Route
            path="permission/*"
            element={
              <PermissionRoute>
                <PermissionRouter />
              </PermissionRoute>
            }
          />

          <Route
            path="helpandsupport/*"
            element={
              <HelpAndSupportRoute>
                <HelpAndSupportRouter />
              </HelpAndSupportRoute>
            }
          />

          <Route
            path="student-portal/*"
            element={
              <StudentPortalRoute>
                <StudentPortalRouter />
              </StudentPortalRoute>
            }
          />

          <Route
            path="/privileges/*"
            element={
              <HodRoute>
                <PrivilegesRouter />
              </HodRoute>
            }
          />

          <Route
            path="reffer/*"
            element={
              <RefferelRoute>
                <RefferelRouter />
              </RefferelRoute>
            }
          />
          <Route
            path="asset-management/*"
            element={
              <AssetMangementRoute>
                <AssetmanagementRouter />
              </AssetMangementRoute>
            }
          />

          <Route
            path="point-tracker/*"
            element={
              <PointTrackerRoute>
                <PointTrackerRouter />
              </PointTrackerRoute>
            }
          />

          <Route
            path="career-connect/*"
            element={
              <CareerRoute>
                <CareerRouter />
              </CareerRoute>
            }
          />

          {/* </Route> */}
        </Route>

        <Route
          path="employeeservices/*"
          element={
            <EmployeeServiceRoute>
              <EmployeeServiceRouter />
            </EmployeeServiceRoute>
          }
        />
        <Route
          path="appraisal-management/*"
          element={
            <AppraisalManagementRoute>
              <AppraisalManagementRouter />
            </AppraisalManagementRoute>
          }
        />
        <Route
          path="top-management/*"
          element={
            <TopManagementRoute>
              <TopManagementRouter />
            </TopManagementRoute>
          }
        />
        <Route
          path="task-management/*"
          element={
            <TaskManagementRoute>
              <TaskManagementRouter />
            </TaskManagementRoute>
          }
        />
        <Route
          path="grievance/*"
          element={
            <GrievanceRoute>
              <GrievanceRouter />
            </GrievanceRoute>
          }
        />
        <Route
          path="cims/*"
          element={
            <CimsRoute>
              <CimsRouter />
            </CimsRoute>
          }
        />
      </Route>

      <Route path="*" element={<Page404 />} />
    </Routes>
  );
};

export default MainRouter;
